import { z } from 'zod'
import { MEMBER_ID_REGEX } from '../constants'

export function getMemberFullName(member: { firstName?: string | null; lastName?: string | null }): string | null {
  const name = [member.firstName, member.lastName].filter(Boolean).join(' ')
  return name || null
}

export function isValidMemberSearchQuery(query: string): boolean {
  const trimmed = query.trim()
  return z.string().email().safeParse(trimmed).success || MEMBER_ID_REGEX.test(trimmed)
}